import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, url, image }) => {
    const defaultTitle = "Gio Billing";
    const defaultDescription = "Gio Billing - Modern POS, Billing, and Inventory Management System. Streamline your business with our powerful and intuitive billing solution.";
    const defaultKeywords = "billing software, pos system, inventory management, gst billing, small business software";
    const defaultUrl = "https://giobilling.com";
    const defaultImage = "/brand-logo.png"; // Use absolute path from public directory

    const seoTitle = title ? `${title} | Gio Billing` : defaultTitle;
    const seoDescription = description || defaultDescription;
    const seoKeywords = keywords || defaultKeywords;
    const seoUrl = url ? `${defaultUrl}${url}` : defaultUrl;
    const seoImage = image || defaultImage;

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{seoTitle}</title>
            <meta name="description" content={seoDescription} />
            {seoKeywords && <meta name="keywords" content={seoKeywords} />}
            <link rel="canonical" href={seoUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={seoUrl} />
            <meta property="og:title" content={seoTitle} />
            <meta property="og:description" content={seoDescription} />
            <meta property="og:image" content={seoImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={seoUrl} />
            <meta property="twitter:title" content={seoTitle} />
            <meta property="twitter:description" content={seoDescription} />
            <meta property="twitter:image" content={seoImage} />
        </Helmet>
    );
};

export default SEO;
